export default __webpack_public_path__ + "static/google-play-badge-545e0703ab03d6df97fa6deea4f69c87.png";